// test2564
(2564 && 0);
